import { render, staticRenderFns } from "./ManualTaskModal.vue?vue&type=template&id=2cf18325"
import script from "./ManualTaskModal.vue?vue&type=script&lang=js"
export * from "./ManualTaskModal.vue?vue&type=script&lang=js"
import style0 from "./ManualTaskModal.vue?vue&type=style&index=0&id=2cf18325&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports